import { apiFetch } from "../auth/apiClient";

// Daily Help (domestic staff) — resident CRUD + gate attendance toggle.
// Backend: /api/domestic-staff/* (see backend/app/api/domestic_staff.py).
export const dailyHelpApi = {
  // ---- resident ----
  list: ({ signal } = {}) =>
    apiFetch("/api/domestic-staff", { authRequired: true, signal }),
  create: (body, { signal } = {}) =>
    apiFetch("/api/domestic-staff", {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),
  update: (id, body) =>
    apiFetch(`/api/domestic-staff/${id}`, {
      method: "PATCH",
      authRequired: true,
      body,
    }),
  retire: (id) =>
    apiFetch(`/api/domestic-staff/${id}/retire`, {
      method: "POST",
      authRequired: true,
    }),
  attendance: (id, { signal } = {}) =>
    apiFetch(`/api/domestic-staff/${id}/attendance`, {
      authRequired: true,
      signal,
    }),
  // The caller's APPROVED villa memberships, as { id, number }.
  myVillas: async ({ signal } = {}) => {
    const me = await apiFetch("/api/users/me", { authRequired: true, signal });
    return (me.memberships || [])
      .filter((m) => m.approval_status === "APPROVED" && m.villa)
      .map((m) => ({ id: m.villa.id, number: m.villa.villa_number }));
  },

  // ---- gate operator ----
  gateRoster: ({ signal } = {}) =>
    apiFetch("/api/domestic-staff/gate", { authRequired: true, signal }),
  gateScan: (body, { signal } = {}) =>
    apiFetch("/api/domestic-staff/gate/scan", {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),
};

export const HELP_KINDS = [
  "MAID",
  "COOK",
  "DRIVER",
  "NANNY",
  "GARDENER",
  "CARETAKER",
  "OTHER",
];

export function helpKindLabel(kind) {
  if (!kind) return "Help";
  return kind.charAt(0) + kind.slice(1).toLowerCase();
}
